(function () {
  'use strict';

  var lazyObserver;
  var bgObserver;

  function markLoaded(img) {
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  function unveil(img) {
    if (!img || img.dataset.whfLoaded === '1') return;
    img.dataset.whfLoaded = '1';

    if (img.dataset.sizes === 'auto') {
      var width = Math.ceil(img.getBoundingClientRect().width || img.parentElement && img.parentElement.getBoundingClientRect().width || 0);
      if (width) img.sizes = width + 'px';
    } else if (img.dataset.sizes) {
      img.sizes = img.dataset.sizes;
    }

    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;

    if (img.complete && img.currentSrc) {
      markLoaded(img);
    } else {
      img.addEventListener('load', function () { markLoaded(img); }, { once: true });
      img.addEventListener('error', function () { markLoaded(img); }, { once: true });
    }
  }

  function observeLazy(img) {
    if (!img || img.dataset.whfObserved === '1') return;
    img.dataset.whfObserved = '1';
    if (lazyObserver) lazyObserver.observe(img); else unveil(img);
  }

  function initLazyImages() {
    if ('IntersectionObserver' in window) {
      lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          lazyObserver.unobserve(entry.target);
          unveil(entry.target);
        });
      }, { rootMargin: '320px 0px', threshold: 0.01 });
    }

    document.querySelectorAll('img.lazyload').forEach(observeLazy);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches('img.lazyload')) observeLazy(node);
            if (node.querySelectorAll) node.querySelectorAll('img.lazyload').forEach(observeLazy);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function initLazyBackgrounds() {
    var nodes = document.querySelectorAll('[data-whf-bg-lazy]');
    if (!nodes.length) return;
    function load(el) { el.classList.add('whf-bg-loaded'); }
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(load);
      return;
    }
    bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        bgObserver.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '700px 0px', threshold: 0.01 });
    nodes.forEach(function (el) { bgObserver.observe(el); });
  }

  var loadedScripts = {};
  function loadScript(src) {
    if (!src || loadedScripts[src] || document.querySelector('script[src="' + src + '"]')) return;
    loadedScripts[src] = true;
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }

  function activateOnIntent(callback, fallbackMs) {
    var done = false;
    function activate() {
      if (done) return;
      done = true;
      ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (name) {
        window.removeEventListener(name, activate, true);
      });
      callback();
    }
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (name) {
      window.addEventListener(name, activate, { once: true, passive: true, capture: true });
    });
    setTimeout(activate, fallbackMs);
  }

  function initLateScripts() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-whf-late-script]'));
    if (!nodes.length) return;
    activateOnIntent(function () {
      nodes.forEach(function (el) {
        loadScript(el.getAttribute('data-whf-late-script'));
        el.classList.add('is-load');
      });
    }, 3000);
  }

  function initAppScripts() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-whf-app-script]'));
    if (!nodes.length) return;
    activateOnIntent(function () {
      nodes.forEach(function (el) {
        loadScript(el.getAttribute('data-whf-app-script'));
      });
    }, 8000);
  }

  function init() {
    initLazyImages();
    initLazyBackgrounds();
    initLateScripts();
    initAppScripts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
